import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

const Haku = (props) => {
  const { tila, asetatila } = props;
  const navigate = useNavigate();

  function handleClick(event) {
    if (event.target.id === "kori") navigate("/kori");
    else if (event.target.id === "otsikko") {
      document.getElementById("hakuLaatikko").value = "";
      document.getElementById("kaikki").checked = true;
      asetatila("haku", { sivu: 0 });
      navigate("/");
    }
  }
  function handleChange(event) {
    event.preventDefault();
    event.target.focus();
    asetatila("haku", { teksti: event.target.value });
    navigate("/");
  }
  window.addEventListener(
    "keydown",
    function ret(e) {
      if (
        e.keyIdentifier === "U+000A" ||
        e.keyIdentifier === "Enter" ||
        e.keyCode === 13
      ) {
        if (e.target.nodeName === "INPUT" && e.target.type === "search") {
          e.preventDefault();
          document.getElementById(e.target.id).blur();
          return false;
        }
      }
    },
    true
  );
  const polku = useLocation().pathname;
  const lkm = tila.kori.get("lkm") ? "(" + tila.kori.get("lkm") + ")" : "";
  const hn = tila.kori.get("lkm") && polku !== "/kori" ? true : false;
  const h = "haku " + (hn ? "hakuKoriNapilla" : "");
  const hl =
    "hakuLaatikko hakuLaatikko" +
    (tila.kori.get("lkm") || polku === "/kori" ? "2" : "1");
  return (
    <form>
      <div className={h}>
        <div className="otsikko" id="otsikko" onClick={handleClick}>
          Gaimport Ky
        </div>
        <div className="välineteksti">
          {tila.frisbee
            ? "Daredevil-frisbeegolfkiekkoja"
            : "Välineitä ja kirjoja pelaajille"}
        </div>
        <div className="hakuKääre">
          <input
            className={hl}
            type="search"
            id="hakuLaatikko"
            onChange={handleChange}
            placeholder="Hae..."
            value={tila.haku.teksti}
          />
          {/* <button className="tyhjennä" type="reset">
            X
          </button> */}
        </div>
        {hn && (
          <div>
            <Link to="/kori">
              <button
                className="nappi nappi1 koriNappi"
                title="Näytä ostoskori"
                id="kori"
              >
                Kori {lkm}
              </button>
            </Link>
          </div>
        )}
      </div>
    </form>
  );
};
export default Haku;
